import CollectionsTabSelector from '@components/collection/CollectionsTabSelector'
import SearchInput from '@components/shared/SearchInput'
import { MdCreateNewFolder, MdFolderOff } from 'react-icons/md'

const CollectionsToolbar = ({
    vm,
}) => {
    
    return (
        
        <div className="flex justify-between items-center content-center gap-4">
            
            {vm.remoteConfig?.halfile?.enabled &&
                <CollectionsTabSelector activeTab="collections" />}
            
            <div className="collections-search-container mb-4 grow">
                
                <div className="flex items-center content-center justify-between w-full gap-2">
                    
                    <SearchInput
                        className="w-full grow"
                        value={vm.query}
                        placeholder="Search collections..."
                        onChange={e => vm.setQuery(e.target.value.toLowerCase())}/>
                    
                    <div {...vm.createCollectionHover} className="shrink-0">
                        <button
                            className="btn btn-primary"
                            onClick={vm.showAddNewCollectionDialog}
                            disabled={!vm.createCollection}
                            data-test-id="CollectionsCreateCollectionButton">
                            <MdCreateNewFolder className="text-xl" />
                            New Collection
                        </button>
                    </div>
                    
                    {vm.anyChecked && (
                        <div className="shrink-0">
                            <button
                                className="btn btn-error"
                                onClick={vm.onDeleteMultipleClick}
                                disabled={!vm.anyChecked || vm.isDeletingCollections}
                                data-test-id="CollectionsDeleteCheckedCollectionsButton">
                                <MdFolderOff className="text-xl" />
                                Delete Collections
                                {vm.isDeletingCollections && (
                                    <span className="loading loading-spinner loading-sm" />
                                )}
                            </button>
                        </div>
                    )}
                
                </div>
            
            </div>
        
        </div>
        
    )
    
}

export default CollectionsToolbar
